import { HTMLAttributes } from 'react';

import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import scssVariables from '@styles/variables.module.scss';
import { useTranslation } from 'react-i18next';

import styles from './SelectInputCreateItemOption.module.scss';
import { Icon } from '@/components/ui/Icon';
import { uiIcons } from '@/constants/uiIcons';

export const SelectInputCreateItemOption = ({
  className,
  currentSearchInput,
  onClick,
  props,
  'data-automation-id': dataAutomationId = 'select-input-create-item-option',
}: {
  className?: string;
  currentSearchInput?: string;
  onClick: () => void;
  props?: HTMLAttributes<HTMLLIElement>;
  'data-automation-id'?: string;
}) => {
  const { t } = useTranslation('forms');
  const trimmedInput = currentSearchInput?.trim() ?? '';

  return (
    <>
      <hr className={styles.Separator} />
      <MenuItem
        {...props}
        className={className}
        key="add_new_option"
        value="add_new_option"
        onClick={onClick}
        data-automation-id={dataAutomationId}
      >
        <ListItemIcon>
          <div className={styles.AddIconContainer}>
            <Icon
              name={uiIcons.actions.add}
              color={scssVariables.ColorBlue80}
            />
          </div>
        </ListItemIcon>
        <ListItemText>
          {trimmedInput.length
            ? t('select.CreateNewInput', { input: trimmedInput })
            : t('select.CreateNewDefault')}
        </ListItemText>
      </MenuItem>
    </>
  );
};
